import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { omitTopLevelId } from '#/api/adapters/patchBody';

export async function updateMtr(id, payload) {
  const { data: raw } = await request.patch(`/mtr/${id}`, keysToSnake(omitTopLevelId(payload)));
  return parseVer4DetailResponse(raw);
}
